/**
 * Une clases y deja que la última gane.
 *
 * Sin esto, `<Button className="bg-danger">` no podría sobrescribir el fondo
 * del componente: ambas clases quedarían en el atributo y decidiría el orden
 * del CSS, no el de la llamada. La resolución es deliberadamente parcial —sólo
 * cubre los prefijos que el proyecto usa— porque una implementación completa
 * de la precedencia de Tailwind es una dependencia, no una utilidad de 20
 * líneas.
 */
const GRUPOS = [
  'bg',
  'text',
  'border',
  'rounded',
  'px',
  'py',
  'pt',
  'pb',
  'pl',
  'pr',
  'p',
  'mx',
  'my',
  'mt',
  'mb',
  'ml',
  'mr',
  'm',
  'w',
  'h',
  'gap',
  'grid-cols',
  'items',
  'justify',
  'shadow',
  'ring',
  'opacity',
];

export function cn(...values: Array<string | false | null | undefined>): string {
  const clases = values.filter(Boolean).join(' ').split(/\s+/).filter(Boolean);
  const porGrupo = new Map<string, string>();
  const sueltas: string[] = [];

  for (const clase of clases) {
    // El modificador forma parte de la identidad: `hover:bg-x` no pisa a `bg-y`.
    const [modificadores, base] = partir(clase);
    const grupo = GRUPOS.find((g) => base.startsWith(`${g}-`) || base === g);

    if (grupo) porGrupo.set(`${modificadores}|${grupo}`, clase);
    else sueltas.push(clase);
  }

  return [...sueltas, ...porGrupo.values()].join(' ');
}

function partir(clase: string): [string, string] {
  const corte = clase.lastIndexOf(':');
  return corte === -1 ? ['', clase] : [clase.slice(0, corte), clase.slice(corte + 1)];
}
